import React, { useState } from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import ReferralLink from "./ReferralLink";

const PromoCodeCard = ({ affiliate }) => {
  const [copied, setCopied] = useState(null);

  if (!affiliate) return null;

  const code = affiliate.promo_code;

  const handleCopy = async (value, label) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(label);
      setTimeout(() => setCopied(null), 1500);
    } catch (e) {
      console.error("Clipboard copy failed:", e);
    }
  };

  const discountText = affiliate.discount_rate
    ? `${Math.round(affiliate.discount_rate * 100)}% off`
    : "discount";
  const commissionText = affiliate.commission_rate
    ? `${Math.round(affiliate.commission_rate * 100)}%`
    : "commission";

  return (
    <Card className="shadow-sm" style={{ border: "none" }}>
      <Card.Body>
        <div
          style={{
            fontSize: "12px",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            color: "#777",
            marginBottom: "12px",
          }}
        >
          Your Promo Code
        </div>

        <Row className="align-items-center g-3">
          <Col xs={12} md={8}>
            <div
              style={{
                fontFamily: "monospace",
                fontSize: "28px",
                fontWeight: 700,
                color: "darkgreen",
                padding: "10px 14px",
                background: "#f5f8f4",
                borderRadius: "6px",
                textAlign: "center",
              }}
            >
              {code}
            </div>
          </Col>
          <Col xs={12} md={4}>
            <Button
              variant="outline-success"
              className="w-100"
              onClick={() => handleCopy(code, "code")}
            >
              {copied === "code" ? "Copied!" : "Copy Code"}
            </Button>
          </Col>
        </Row>

        <div
          style={{
            fontSize: "12px",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            color: "#777",
            margin: "20px 0 10px",
          }}
        >
          Your Share Link
        </div>
        <ReferralLink promoCode={code} />

        <p style={{ fontSize: "13px", color: "#666", marginTop: "16px" }}>
          Share this link with your audience — it sends them to the right app
          store automatically (App Store on iPhone, Google Play on Android) and
          credits installs and subscriptions to you. They get{" "}
          <b>{discountText}</b> on their Sarv subscription. You earn a one-time{" "}
          <b>{commissionText}</b> commission when a new referred customer
          completes their first paid subscription after the free trial. Renewals
          are tracked but are not commissionable.
        </p>
      </Card.Body>
    </Card>
  );
};

export default PromoCodeCard;
